(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/init.js');
'use strict';

var _svs;
const {
  MyProfileApp,
  UnsubscribePage
} = svs.myProfile;
const loadUnsubscribe = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.my_profile_react) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.loadUnsubscribe) || false;
svs.myProfile.init = () => {
  ReactDOM.render(loadUnsubscribe ? React.createElement(UnsubscribePage, null) : React.createElement(MyProfileApp, null), document.getElementsByClassName('js-player-profile-react-container')[0]);
};
svs.myProfile.init();

 })(window);